<template>
  <login-layout>
    <form class="t-login__form" @submit.prevent >
      <div class="t-login__field">
        <label for="email" class="control-label">Email:</label>
        <input
          class="form-control"
          id="email"
          type="email"
          name="email"
          v-model="email"
          autofocus />
        <span class="help-block" v-if="errorMessages.email">{{ errorMessages.email }}</span>
      </div>

      <div v-if="token" class="t-login__field"  >
        <label for="password" class="control-label">Password:</label>
        <input
          id="password"
          type="password"
          class="form-control"
          name="password"
          v-model="password"/>
        <span class="help-block" v-if="errorMessages.password">{{ errorMessages.password }}</span>
      </div>

      <div v-if="token" class="t-login__field"  >
        <label for="confirm-password" class="control-label">Confirm Password:</label>
        <input
          id="confirm-password"
          type="password"
          class="form-control"
          name="password"
          v-model="passwordConfirmation"/>
        <span class="help-block" v-if="errorMessages.passwordConfirmation">{{ errorMessages.passwordConfirmation }}</span>
      </div>

      <ladda-button
        ref="search"
        class="btn btn-dark"
        type="submit"
        :click="handleSubmit">
        Reset
      </ladda-button>
    </form>

  </login-layout>
</template>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'
import LoginLayout from './auth/LoginLayout'
import {required, sameAs, minLength, helpers as validationHelpers} from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      email: '',
      password: '',
      passwordConfirmation: ''
    }
  },

  props: {
    token: {
      type: String,
      default: null
    }
  },

  components: {
    LoginLayout
  },

  validations () {
    if (this.token) {
      return {
        email: {
          required
        },
        password: {
          required,
          minLength: minLength(6),
          passwordRules: validationHelpers.regex('passwordRules', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)
        },
        passwordConfirmation: {
          sameAsPassword: sameAs('password')
        }
      }
    }

    return {
      email: {
        required
      }
    }
  },

  computed: {

    errorMessages () {
      let errors = {}

      const messages = {
        email: {
          required: 'Email Address is required.'
        },
        password: {
          required: 'A password is required.',
          minLength: 'Passwords must be at least 6 characters.',
          passwordRules: 'Password must contain a lowercase letter, an uppercase letter and a number.'
        },
        passwordConfirmation: {
          sameAsPassword: 'The password confirmation field does not match.'
        }
      }

      if (!this.$v.$error) { return errors }

      for (const [field, fieldMessages] of Object.entries(messages)) {
        if (!this.$v[field] || !this.$v[field].$invalid) continue

        for (const [rule, ruleMessage] of Object.entries(fieldMessages)) {
          if (this.$v[field][rule] === false) {
            errors[field] = ruleMessage
            break
          }
        }
      }

      return errors
    }

  },

  methods: {
    ...mapActions('user', ['resetPassword', 'updatePassword']),

    handleSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }

      if (this.token) {
        return this.updatePassword({
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }).then(() => {
          notify.success('Your password has been reset. Please login.')
          this.$router.push({ name: 'login' })
        }).catch((e) => {
          notify.error((e.response && e.response.data.message) ? e.response.data.message : 'Unable to reset password for that email address.')
        })
      }

      return this.resetPassword({ email: this.email }).then(() => {
        notify.success('We have sent you a link to reset your password. Please check your email.')
        this.$router.push({ name: 'login' })
      }).catch(() => {
        notify.error('Unable to reset password for that email address.')
      })
    }

  }
}
</script>
